import React from "react";
import { PremiumSubscriptionTemplate } from "themes/application/payment/pages";

class PremiumSubscription extends React.Component {
    render() {
        return <PremiumSubscriptionTemplate {...this.props} />;
    }
}

export default PremiumSubscription;
